/*
 * @Author: your name
 * @Date: 2021-08-20 12:06:25
 * @LastEditTime: 2026-06-28 14:00:52
 * @LastEditors: qiuhc 2282747917@qq.com
 * @Description: 环境配置
 * @FilePath: \Reptilec:\Users\Administrator\Desktop\data\vue-element-ui-admin\src\config\url.js
 */
// const devApiUrl = "http://106.53.85.129:8099"; //本地开发环境
// const devApiUrl = "https://api.youxingyujian.top"; //本地开发环境
const devApiUrl = "http://192.168.43.7:19890"; //本地开发环境
const buildDevApiUrl = "http://106.55.198.93:8099"; //打包开发环境
const buildTestApiUrl = "http://106.55.198.93:8099"; //打包测试环境3
const buildPreApiUrl = "http://106.55.198.93:8099"; //打包测试环境
// const buildProApiUrl = "https://api.xxx.cn"; //打包正式环境
const buildProApiUrl = "https://api.youxingyujian.top"; //打包正式环境

/** 云盘静态文件访问域名（/cc/ 路径前缀） */
const staticFileUrl = "https://youxingyujian.top";

let useApiUrl;
let useStaticFileUrl = staticFileUrl;

if (process.env.NODE_ENV === "development") {
  useApiUrl = devApiUrl;
} else {
  //production
  switch (process.env.VUE_APP_MODE) {
    case "buildDev":
      useApiUrl = buildDevApiUrl;
      break;
    case "buildTest":
      useApiUrl = buildTestApiUrl;
      break;
    case "buildPre":
      useApiUrl = buildPreApiUrl;
      break;
    default:
      useApiUrl = buildProApiUrl;
      break;
  }
}

export { useApiUrl, useStaticFileUrl }; //可以导出更多需要不同环境区分的url
